import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Config from "../../config";
import { PaymentGateway } from "../../../../services/payment-gateway";
import RedeemVoucher, { VouchersPageEmbedded } from "../../../jamibet/mobile-components/vouchers/redeem-voucher";
import CreateVoucher from "../../../jamibet/mobile-components/vouchers/create-voucher";
import * as U from "../../../jamibet/desktop-templates/menu-user";
import User from "../../../../services/user";
import { WalletsPanel } from "../../../jamibet/mobile-components/site/menu-right";
import formatCurrency from "../../../../services/currency";
import { useDepositTransaction } from "../../../jamibet/desktop-components/user/payment-gateway/deposit/logic";
import { DepositAmountPage, CheckPhonePage } from "../../../jamibet/desktop-components/user/payment-gateway/deposit/components";
import { useWithdrawTransaction } from "../../../jamibet/desktop-components/user/payment-gateway/withdraw/logic";
import { WithdrawAmountPage, ProcessingWithdrawPage } from "../../../jamibet/desktop-components/user/payment-gateway/withdraw/components";
import { Spinner, ErrorMessage, GatewayContainer, SuccessPage, WaitSuccessPage, FullSizeIframe } from "../../../jamibet/desktop-components/user/payment-gateway/shared/components";
import AwrabetPaymentGatewayPage from "../../../awrabet/desktop-components/user/menu-payment-gateway";
import { P2PPage } from "../../../awrabet/mobile-components/p2p/p2p-pages";
import { TelegramDepositPage, TelegramWithdrawPage } from "../../../awrabet/mobile-components/p2p/telegram-pages";
import { ManualDepositPage } from "../../../awrabet/desktop-components/user/payment-gateway/manual-deposit/ManualDepositPage";
import { ManualWithdrawPage } from "../../../awrabet/desktop-components/user/payment-gateway/manual-withdraw/ManualWithdrawPage";

const createDepositPage = (dependencies) => {
	const { useDepositTransaction, DepositAmountPage, CheckPhonePage, Spinner, ErrorMessage, GatewayContainer, SuccessPage, WaitSuccessPage, FullSizeIframe } = dependencies;
	return (props) => {
		const { step, error, formUrl, statusUrl, initiateTransaction, handleTransactionStatus, reset } = useDepositTransaction({ provider: props });

		const renderStep = () => {
			switch (step) {
				case 'start':
					return <Fragment>
						<DepositAmountPage
							requestDeposit={initiateTransaction}
							showPhoneNumber={<div class="w-full text-sm text-slate-500 pt-1 text-right">
								<span><Trans>Phone Number</Trans>:</span> +251{User.username()}
							</div>}
						/>
						<GatewayContainer>
							<div class="text-left text-xs text-slate-800">
								<div class="text-base font-bold">ገቢ በተመለከት</div>
								<div class="pt-1">በዋሌቶ አሁን ያለዎት ሂሳብ</div>
								<div class="pt-1">
									<WalletsPanel
										balance={formatCurrency(User.balance())}
										payable={formatCurrency(User.payable())}
										bonus={formatCurrency(User.bonus())}
									/>
								</div>
							</div>
						</GatewayContainer>
					</Fragment>;
				case 'wait':
					return <Spinner />;
				case 'error':
					return <ErrorMessage error={error} />;
				case 'external-pay-form':
					return <FullSizeIframe formurl={formUrl} />;
				case 'pending':
					return <CheckPhonePage statusUrl={statusUrl} onEvent={handleTransactionStatus} />;
				case 'success-wait':
					return <WaitSuccessPage />;
				case 'success':
					return <SuccessPage onRepeat={reset} />;
				default:
					return null;
			}
		};

		return <div class="grow w-full flex flex-col items-center text-slate-800 bg-linear-to-br from-fuchsia-300 to-blue-300 overflow-auto">
			{renderStep()}
		</div>;
	};
};

const createWithdrawPage = (dependencies) => {
	const { useWithdrawTransaction, WithdrawAmountPage, ProcessingWithdrawPage, Spinner, ErrorMessage, GatewayContainer, SuccessPage } = dependencies;
	return (props) => {
		const { step, error, statusUrl, initiateTransaction, handleTransactionStatus, reset } = useWithdrawTransaction({ provider: props });

		const renderStep = () => {
			switch (step) {
				case 'start':
					return <Fragment>
						<WithdrawAmountPage
							requestWithdraw={initiateTransaction}
							showMaxAmount={{
								altDesc: 'ወጪ ማድረግ የሚችሉት የብር መጠን',
								description: <Trans>Max Withdrawable</Trans>,
								value: User.payable()
							}}
						/>
						<GatewayContainer>
							<div class="text-left text-xs text-slate-800">
								<div class="text-base font-bold">ወጪ በተመለከት</div>
								<div class="pt-1">በዋሌቶ አሁን ያለዎት ሂሳብ</div>
								<div class="pt-1">
									<WalletsPanel
										balance={formatCurrency(User.balance())}
										payable={formatCurrency(User.payable())}
										bonus={formatCurrency(User.bonus())}
									/>
								</div>
							</div>
						</GatewayContainer>
					</Fragment>;
				case 'wait':
					return <Spinner />;
				case 'error':
					return <ErrorMessage error={error} />;
				case 'pending':
					return <ProcessingWithdrawPage statusUrl={statusUrl} onEvent={handleTransactionStatus} />;
				case 'success':
					return <SuccessPage onRepeat={reset} />;
				default:
					return null;
			}
		};

		return <div class="grow w-full flex flex-col items-center text-slate-800 bg-linear-to-br from-fuchsia-300 to-blue-300 overflow-auto">
			{renderStep()}
		</div>;
	};
};

const createGatewaySelector = (dependencies) => {
    const { DepositPage, WithdrawPage } = dependencies;

    return class GatewaySelector extends Component {
        service = new PaymentGateway(Config.softionAPI);
        state = {
            page: 'start',
            services: null,
            provider: null
        };

        customPages = {
			p2p: {  processor: 'p2p', provider: 'exchange', name: 'Exchange', deposit: () => <P2PPage defaultPage="offers" />, withdraw: () => <P2PPage defaultPage="withdraw" />, bonusPerc: 100 },
            voucher: { processor: 'voucher', provider: 'voucher', name: 'Voucher', deposit: RedeemVoucher, withdraw: CreateVoucher },
            ...(Config.allowP2P ? { telegram: { processor: 'telegram', provider: 'telegram', name: 'Telegram', deposit: TelegramDepositPage, withdraw: TelegramWithdrawPage } } : {}),
            ...(Config.allowManualDeposit ? { 'manual-deposit': { processor: 'manual-deposit', provider: 'manual-deposit', name: 'Manual Deposit', deposit: ManualDepositPage, withdraw: ManualDepositPage } } : {}),
            ...(Config.allowManualWithdraw ? { 'manual-withdraw': { processor: 'manual-withdraw', provider: 'manual-withdraw', name: 'Manual Withdraw', deposit: ManualWithdrawPage, withdraw: ManualWithdrawPage } } : {}),
        };

        componentWillMount() {
            this.service.requestServicesList().then(response => {
                this.setState({ services: response });
            });
        }

        asProcessorDesc = (proc) => {
            return { ...proc, withdraw: WithdrawPage, deposit: DepositPage };
        }

		getProviders() {
			const services = this.state.services || { withdraw: [], deposit: [] };
			const md = this.customPages['manual-deposit'];
			const mw = this.customPages['manual-withdraw'];
			const rest = Object.values(this.customPages).filter(p => p !== md && p !== mw);
			return {
				withdraw: [...(mw ? [mw] : []), ...services.withdraw.map(this.asProcessorDesc), ...rest.filter(p => p.withdraw)],
				deposit: [...services.deposit.map(this.asProcessorDesc), ...rest, ...(md ? [md] : [])],
			}
        }

        setProvider = (provider) => {
            this.setState({ page: 'provider', provider: provider })
        }

        render() {
            if (this.state.page == 'start') {
                return <div class="grow w-full flex flex-col items-center pt-3 text-slate-800">
                    <div class="text-xl">{this.props.tab == 'deposit' ? <Trans>Deposit</Trans> : <Trans>Withdraw</Trans>}</div>
                    <div class="flex flex-col items-center w-full max-w-sm backdrop-blur-xl bg-white rounded p-4 gap-2">
                        {this.getProviders()[this.props.tab].map(
                            row => <GatewayRow row={row} choseProvider={this.setProvider} />
                        )}
                    </div>
                </div>
            }
            const GatewayInnerPage = this.state.provider[this.props.tab];
            return <GatewayInnerPage key={this.state.provider.provider} provider={this.state.provider.provider} processor={this.state.provider.processor} name={this.state.provider.name} />;
        }
    }
};

const depositPageDependencies = {
    useDepositTransaction,
    DepositAmountPage,
    CheckPhonePage,
    Spinner,
    ErrorMessage,
    GatewayContainer,
    SuccessPage,
    WaitSuccessPage,
    FullSizeIframe,
};

const withdrawPageDependencies = {
    useWithdrawTransaction,
    WithdrawAmountPage,
    ProcessingWithdrawPage,
    Spinner,
    ErrorMessage,
    GatewayContainer,
    SuccessPage,
};

const DepositPage = createDepositPage(depositPageDependencies);
const WithdrawPage = createWithdrawPage(withdrawPageDependencies);

const gatewaySelectorDependencies = {
    DepositPage,
    WithdrawPage,
};

const GatewaySelector = createGatewaySelector(gatewaySelectorDependencies);

export default class PaymentGatewayPage extends AwrabetPaymentGatewayPage {
	render() {
		return <div class="grow h-full min-h-[inherit] flex flex-col">
			<U.SubTabsContainer>
				{Object.entries(this.tabs).filter(([k, tab]) => tab.visible).map(([key, item]) => {
					return <U.Tab selected={key === this.state.current} onClick={() => this.switchTabs(key)} >{item.label}</U.Tab>;
				})}
			</U.SubTabsContainer>
			<div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded hidden">{this.tabs[this.state.current].description}</div>
			{this.state.current == 'deposit' || this.state.current == 'withdraw' ?
				<GatewaySelector key={this.state.current} tab={this.state.current} /> : null}
			{this.state.current == 'vouchers' ? 
				<VouchersPageEmbedded />
			: null}
			{this.state.current == 'p2p-deposits' ? 
				<P2PPage defaultPage="my-purchases" />
			: null}
			{this.state.current == 'p2p-withdraws' ? 
				<P2PPage defaultPage="my-offers" />
			: null}
			{this.state.current == 'manual-deposit' ? 
				<ManualDepositPage processor="manual-deposit" provider="manual-deposit" name="Manual Deposit" />
			: null}
			{this.state.current == 'manual-withdraw' ? 
				<ManualWithdrawPage processor="manual-withdraw" provider="manual-withdraw" name="Manual Withdraw" />
			: null}
		</div>;
	}
}

const processorIcons = {
	telebirr: require('url:../../assets/img/logo_provider/telebirr.png'),
	telebirrussd: require('url:../../assets/img/logo_provider/telebirr.png'),
	cbebirr: require('url:../../assets/img/logo_provider/cbebirr.png'),
	cbe: require('url:../../assets/img/logo_provider/cbebirr.png'),
	mpesa: require('url:../../assets/img/logo_provider/mpesa-logo.png'),
	exchange: require('url:../../../awrabet/assets/img/logo_provider/p2p.svg'),
	voucher: require('url:../../assets/img/logo_provider/voucher.svg'),
	telegram: require('url:../../assets/img/logo_provider/telegram.svg'),
	manualwithdraw: require('url:../../assets/img/logo_provider/telebirr.png'),
	manualdeposit: require('url:../../assets/img/logo_provider/vouchers.png'),
	automaticdeposit: require('url:../../assets/img/logo_provider/telebirr.png'),
};

function GatewayRow({ choseProvider, row }) {
    const providerTag = row.name.toLowerCase().replace(/[^a-z0-9]/g, '');
    const isExchange = row.provider === 'exchange' && row.bonusPerc > 0;

    return <a
        class={`w-full rounded shadow-xl flex gap-1 px-3 py-2 h-24 items-start justify-between hover:scale-110 transition-transform relative ${isExchange ? 'gold-border' : 'border'}`}
        href="javascript:void(0);"
        onClick={() => choseProvider(row)}
    >
		<style>{`
@keyframes shimmer-border {
    0%   { background-position: 0% 50%; }
    50%  { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

.gold-border {
    background:
        linear-gradient(white, white) padding-box,
        linear-gradient(90deg, #b8860b, #ffd700, #fffacd, #ffd700, #b8860b) border-box;
    background-size: 200% 200%;
    border: 2px solid transparent;
    animation: shimmer-border 3s ease infinite;
}
`}</style>
        {isExchange && (
            <span class="absolute top-1.5 left-1/2 -translate-x-1/2 text-xs font-semibold whitespace-nowrap tracking-wide"
                style={{ color: '#b8860b' }}>
                {row.bonusPerc}% deposit bonus
            </span>
        )}
        <div class="h-full flex gap-1 items-center justify-start">
            <img src={processorIcons[providerTag]} alt={row.processor} class="h-full" />
        </div>
        <div class="grow font-bold text-xxs capitalize hidden">{row.name}</div>
        <div class="text-xs text-slate-600">
            <div>via {row.provider}</div>
        </div>
    </a>
}
